export const IconVacancyFolder20: {
  name: 'icon_vacancy_folder_20-6d3509ad40fd'
} = {
  name: 'icon_vacancy_folder_20-6d3509ad40fd'
}
